/**
 * @description Defines variables for use in other parts of the application.
 */
var _a;
/**
 * Class to manage the state of a form.
 * Allows setting and getting various form attributes dynamically.
 */
export class FormState {
    constructor() { }
    /**
     * Generic method to set or get form attributes.
     *
     * @param key - The key (property name) to access or set in the form state.
     * @param value - The value to set for the specified key (if provided). If not provided, it will get the current value.
     * @returns The current value of the property if getting, or void if setting.
     */
    manageState(key, value) {
        if (value !== undefined) {
            FormState.state[key] = value; // Set the value if provided
        }
        return FormState.state[key]; // Get the value if no value is provided
    }
}
// Private variables to store form attributes
FormState.state = {
    typologyId: 0,
    referrer: '',
    formName: '',
    typologyPrice: '',
    typologyType: '',
    typologyIncome: '',
    builderName: '',
    builderNumber: '',
    productOfert: 1,
    origen: 'website',
    anuncio: '',
    contextComponent: 'portal',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: '',
    countryCode: '',
    openCalculator: '',
    eventCalculator: '',
    pricePreregistro: '',
    valueFields: 6,
    resultsCalculator: '',
    pendingLink: '',
    projectRedirect: '',
    schedulingUrl: ''
};
// Exports the 'FormState' class for use in other parts of the application
export const formState = (_a = window.evFormState) !== null && _a !== void 0 ? _a : (window.evFormState = new FormState());
